<template>
  <div>
    <b-button @click="showFilters()" class="filterButton" variant="success">
      <jam-filter />Filters
    </b-button>
    <modal
      id="modal"
      :scrollable="true"
      name="filterModal"
      :adaptive="true"
      width="100%"
      height="auto"
      styles="border-radius: 0px"
    >
      <div id="wrapperDiv" ref="input">
        <b-container>
          <!-- <div id="closeButtonContainer">
            <div id="closeButton">
              <button @click="$modal.hide('filterModal')">✕</button>
            </div>
          </div>-->
          <div>
            <SortBar id="sortBar"></SortBar>
            <Filters id="filters"></Filters>
          </div>
        </b-container>
        <b-button @click="hideFilters()" class="filterButton" id="closeButton2" variant="danger">✕</b-button>
      </div>
    </modal>
  </div>
</template>

<script>
import Filters from "./Filters.vue";
import SortBar from "./SortBar.vue";
export default {
  name: "FilterButtonAndModal",
  components: {
    Filters,
    SortBar
  },
  props: {
    job: Object
  },
  methods: {
    showFilters() {
      this.$modal.show("filterModal");
    },
    hideFilters() {
      this.$modal.hide("filterModal");
    }
  }
};
</script>

<style scoped>
#sortBar {
  padding: 20px 0px;
}
#wrapperDiv {
  min-height: calc(100vh);
}
.filterButton {
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 1;
}
#closeButton {
  text-align: right;
}
#closeButton2 {
}
#closeButton button {
  border: none;
  background: rgba(0, 0, 0, 0.8);
  padding: 13px 20px;
  color: white;
  transition: all 0.2s ease-in-out;
}
#closeButton button:hover {
  background: rgba(0, 0, 0, 1);
}
#filters {
  padding-bottom: 30px;
}
</style>